<template>
	<fieldset class="cam-box" role="radiogroup" aria-labelledby="cam-team-size-legend">
		<div class="columns is-vcentered is-variable is-2-mobile is-4-tablet">
			<div class="column">
				<p id="cam-team-size-legend" class="title is-5 mb-0">How big is your team?</p>
			</div>

			<div class="column is-narrow-tablet">
				<div class="buttons">
					<button
						v-for="(band, index) in bands"
						:key="band.id"
						ref="options"
						type="button"
						role="radio"
						class="button is-rounded team-size-option"
						:class="band.id === selectedBandId ? 'is-orange has-text-navy has-text-weight-bold' : 'is-white'"
						:aria-checked="band.id === selectedBandId"
						@click="selectBand(band.id)"
						@keydown="onOptionKeydown($event, index)"
					>
						{{ band.label }}
					</button>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>

import { TEAM_SIZE_BANDS } from '../calculations.js';

export default {
	data() {
		return {
			bands: TEAM_SIZE_BANDS,
		};
	},

	computed: {
		selectedBandId() {
			return this.$store.band;
		},
	},

	methods: {
		selectBand(bandId) {
			this.$store.setBand(bandId);
		},

		/* Tab visits every option and leaves the selection alone, so moving on
		   to the slider does not rewrite the answer. Arrow keys still move and
		   select, the same as a radio group. */
		onOptionKeydown(event, index) {
			const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
			const backward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
			if (!forward && !backward) {
				return;
			}

			event.preventDefault();
			const count = this.bands.length;
			const nextIndex = forward ? (index + 1) % count : (index - 1 + count) % count;
			this.selectBand(this.bands[nextIndex].id);
			this.$nextTick(() => {
				this.$refs.options[nextIndex].focus();
			});
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.team-size-option {
	&:focus:not(:focus-visible) {
		box-shadow: none;
	}

	&:focus-visible {
		box-shadow: $button-focus-box-shadow-size rgba($blue, .25);
	}
}

</style>
